enum ActionType {
    REQUEST_TREND = '[DASHBOARD/WAS_TREND] GET WAS TREND',
    RECEIVE_TREND = '[DASHBOARD/WAS_TREND] SET WAS TREND',
    TREND_REQUEST_FAILED = '[DASHBOARD/WAS_TREND] WAS TREND REQUEST FAILED',
}

export default ActionType
